import i18next from 'i18next';

const useFeaturePages = () => {
  const len = i18next.language.substring(0, 2);
  return [
    { title: 'Medical Charting', link: `/${len}/solutions/charting` },
    { title: 'Patient Management', link: `/${len}/solutions/patient-management` },
    { title: 'Calendar', link: `/${len}/solutions/calendar` },
    { title: 'Templates', link: `/${len}/solutions/templates` },
  ];
};

export default useFeaturePages;
